import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

import Menu from './Menu.react.js';

class Sidebar extends React.Component {
  static propTypes = {
    menu: PropTypes.instanceOf(List).isRequired
  };

  render() {
    return <Menu menu={this.props.menu} />;
  }
}

export default Sidebar;
